var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.node.nodeDef.appType === _vm.RUNNIT_NODE_DEF_TOOL_APP_TYPE.TRAINER)?_c('div',{staticStyle:{"padding":"15px"}},[_c('runnit-model-static-fields',{attrs:{"node":_vm.node}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }